// import axios from "axios";
// const detailsPageDataAPI = process.env.REACT_APP_GET_DETAILS_API;

// const getDetailsPageDataAPI = async (id) => {
//   const memberId = id.replace(/([A-Z]+)(\d+)/, "$1 $2"); // convert CC101 to CC 101
//   const params = new URLSearchParams({ memberId });
//   const searchParams = params.toString();
//   const response = await axios.get(`${detailsPageDataAPI}&${searchParams}`);
//   return response.data;
// };

// export default getDetailsPageDataAPI;

// import axios from "axios";
// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//   let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   return decryptedData;
// }
// const detailsPageDataAPI = process.env.REACT_APP_GET_DETAILS_API;

// const getDetailsPageDataAPI = async (id) => {
//   const memberId = id.replace(/([A-Z]+)(\d+)/, "$1 $2"); // convert CC101 to CC 101
//   const params = new URLSearchParams({ memberId });
//   const searchParams = params.toString();
//   const response = await axios.get(`${detailsPageDataAPI}&${searchParams}`);
//   const decrypteddata = decryptFunction(response.data, SECRET_KEY);
//   console.log("scertet", decrypteddata);
//   return decrypteddata;
// };

// export default getDetailsPageDataAPI;

// import axios from "axios";
// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//   let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   return decryptedData;
// }
// const detailsPageDataAPI = process.env.REACT_APP_GET_DETAILS_API;

// const getDetailsPageDataAPI = async (id) => {
//   const memberId = id.replace(/([A-Z]+)(\d+)/, "$1 $2"); // convert CC101 to CC 101
//   const params = new URLSearchParams({ memberId });
//   const searchParams = params.toString();
//   const response = await axios.get(`${detailsPageDataAPI}&${searchParams}`);
//   const decrypteddata = decryptFunction(response.data, SECRET_KEY);
//   console.log("scertet", decrypteddata);
//   return decrypteddata;
// };

// export default getDetailsPageDataAPI;

import axios from "axios";
import CryptoJS from "crypto-js";
import { handleLogout } from "./getRequest";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

function decryptFunction(ciphertext, key) {
  // Decrypt
  let bytes = CryptoJS.AES.decrypt(ciphertext, key);
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}

const detailsPageDataAPI = process.env.REACT_APP_GET_DETAILS_API;

const getDetailsPageDataAPI = async (id) => {
  const authToken = localStorage.getItem("authToken");

  const memberId = id.replace(/([A-Z]+)(\d+)/, "$1 $2"); // convert CC101 to CC 101
  const params = new URLSearchParams({ memberId });
  const searchParams = params.toString();

  let response;
  try {
    response = await axios.get(`${detailsPageDataAPI}&${searchParams}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
  } catch (error) {
    if (error.status === 401) {
      console.log("Token expired");
      handleLogout();
      return;
    }
    throw error;
  }

  const decrypteddata = decryptFunction(response.data, SECRET_KEY);
  

  return decrypteddata;
};

export default getDetailsPageDataAPI;
